var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedication(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "A) Icons / Tools / Medication") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M20.2507322,6 L16.5,6 L16.5,5.25 C16.4985793,4.00794828 15.4920517,3.00142074 14.25,3 L9.75,3 C8.50794828,3.00142074 7.50142074,4.00794828 7.5,5.25 L7.5,6 L3.75073219,6 C2.92269764,6.00094699 2.25167918,6.67196545 2.25073219,7.5 L2.25073219,19.5 C2.25167918,20.3280346 2.92269764,20.999053 3.75073219,21 L20.2507322,21 C21.0787667,20.999053 21.7497852,20.3280346 21.7507322,19.5 L21.7507322,7.5 C21.7497852,6.67196545 21.0787667,6.00094699 20.2507322,6 Z M9,5.25 C9.00047375,4.83598283 9.33598283,4.50047375 9.75,4.5 L14.25,4.5 C14.6640172,4.50047375 14.9995262,4.83598283 15,5.25 L15,6 L9,6 L9,5.25 Z M14.625,14.25 L12.75,14.25 L12.75,16.125 C12.75,16.5392136 12.4142136,16.875 12,16.875 C11.5857864,16.875 11.25,16.5392136 11.25,16.125 L11.25,14.25 L9.375,14.25 C8.96078644,14.25 8.625,13.9142136 8.625,13.5 C8.625,13.0857864 8.96078644,12.75 9.375,12.75 L11.25,12.75 L11.25,10.875 C11.25,10.4607864 11.5857864,10.125 12,10.125 C12.4142136,10.125 12.75,10.4607864 12.75,10.875 L12.75,12.75 L14.625,12.75 C15.0392136,12.75 15.375,13.0857864 15.375,13.5 C15.375,13.9142136 15.0392136,14.25 14.625,14.25 Z",
    id: "path-medication"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "A)-Icons-/-Tools-/-Medication",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Medication"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-medication"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "currentColor",
    xlinkHref: "#path-medication"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedication);
export default __webpack_public_path__ + "static/media/medication.72a3a1f2.svg";
export { ForwardRef as ReactComponent };